import { useNavigate } from "react-router-dom"
import { Layout } from "../../../ui/layout"
import Button from "../../../ui/molecules/button"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { useAppSelector } from "../../../lib/redux/hooks"
import { Banner } from "../../../ui/organisms/banner"
import { ListMonitoringBioSuisse } from "./listMonitoringBioSuisse"
import { SOTFilter } from "../../sot"
import { SelectCustom } from "../../../ui/molecules/select"
import { yearOptions } from "../../../utils"

export function MonitoringBiosuisse() {
    const navigate = useNavigate()
    const sessionState = useAppSelector(state => state.session)

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Monitoraggio Biosuisse']}
            noPaddingLat
            headerLabel="Monitoraggio Biosuisse"
        >

            <div>
                <div style={{ display: 'flex', padding: '12px 24px 0px 24px' }}>
                    <div style={{ display: 'flex', flex: '0.65', gap: '24px' }}>
                        <div style={{ flex: '0.5' }}>
                            <div className="text-left">
                                <span className="input-label">Anno</span>
                            </div>
                            <SelectCustom

                                placeholder={'Anno'}
                                options={yearOptions}
                                onChange={(value) => console.log()}
                            />
                        </div>
                        <div style={{ flex: '0.5' }}>
                            <div className="text-left">
                                <span className="input-label">Sede</span>
                            </div>
                            <SOTFilter
                                // disabled={usersState.findMeResponse.headQuarterInfo?.code !== 'SC' && usersState.findMeResponse.role !== 'admin'}
                                onChange={(value) => console.log()}
                            />
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: '18px', alignItems: 'flex-end' }}>
                        <Button
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"link"}
                            label="Pulisci"
                            color={"gray"}
                            onClick={() => console.log()}
                        />
                        <Button
                            variant='outline'
                            color='blue'
                            size='md'
                            iconPosition='off'
                            label='Cerca'
                        // onClick={() => dispatch(GetAllPacDetails({
                        //     page: pacState.getAllPACDetailsFilters.page,
                        //     itemsPerPage: pacState.getAllPACDetailsFilters.itemsPerPage,
                        //     order: true,
                        //     customerId: selectedTab === 0 ? sessionState.selected.customerId! : undefined,
                        //     head_quarter: pacState.getAllPACDetailsFilters.head_quarter,
                        //     year: pacState.getAllPACDetailsFilters.year,
                        //     country: pacState.getAllPACDetailsFilters.country,
                        //     norm: pacState.getAllPACDetailsFilters.norm,
                        //     periodicity: pacState.getAllPACDetailsFilters.periodicity
                        // }))}
                        />
                    </div>
                </div>
                <ListMonitoringBioSuisse />

            </div>
        </Layout>
    )
}